export enum ServiceComponentNames {
  anchor = 'ComponentSectionAnchorSection',
  faq = 'ComponentSectionFaqSection',
  richContent = 'ComponentComponentRichContent',
  roundedNote = 'ComponentComponentRoundedNote',
  guideSection = 'ComponentSectionGuideSection',
  textBanner = 'ComponentComponentTextBanner',
  startSection = 'ComponentSectionColoredSection',
  buttonLink = 'ComponentComponentButtonLink',
}

export enum ServiceComponentNamesRest {
  anchor = 'section.anchor-section',
  faq = 'section.faq-section',
  richContent = 'component.rich-content',
  roundedNote = 'component.rounded-note',
  guideSection = 'section.guide-section',
  textBanner = 'component.text-banner',
  startSection = 'section.colored-section',
  buttonLink = 'component.button-link',
}
